import React, { useState } from 'react';
import { Alert, IconButton, Box } from '@mui/material';

// propsの型定義を行う
type propsType = {
    closeFunc: () => void;
    alertMsg: React.ReactNode;
};

const AlertDialog: React.FC<propsType> = (props) => {
  const { closeFunc, alertMsg } = props;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 760,
        zIndex: 9999,
        backgroundColor: '#f44336',
        borderRadius: '50%'
      }}
    >
      <Alert
        severity="error"
        icon={
          <Box
            sx={{
              width: 24,
              height: 24,
              backgroundColor: 'white',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '0.1px solid #d32f2f',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: '#f44336', 
                borderRadius: '50%',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.875rem',
                fontWeight: 'bold',
              }}
            >
              ！
            </Box>
          </Box>
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            sx={{ color: 'white' }}
            onClick={closeFunc}
          >
            ×
          </IconButton>
        }
        sx={{
            height: '48px',
          bgcolor: 'error.main',
          color: 'white',
          alignItems: 'center',
          fontSize: '0.875rem',
        }}
      >
        ・{alertMsg}
      </Alert>
    </Box>
  );
};

export default AlertDialog;
